
export default item => ({
  ...item,
  collection: item.collection.map(collectionItem => ({
    ...collectionItem,
    slug: `${collectionItem.slug}_${collectionItem.code}`
  }))
})